/**
 * Sidebar navigation items for the Sales section (Customers and Quotes modules).
 * Provides navigation to customers and quotes management.
 * Navigation items are feature-flag gated.
 */
import { Paid, PaidOutlined } from '@mui/icons-material';

import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';
import { NavItemType } from '@/common/presentation/components/layout/Sidebar/type';
import { useFilterNavItemsByFeatureFlags } from '@/common/presentation/utils/filterNavItems';

export interface SalesNavItemsResult {
  item: NavItemType | null;
  isReady: boolean;
}

const SalesNavItems = (): SalesNavItemsResult => {
  const navItems: NavItemType = {
    id: 'sales',
    title: 'Sales',
    type: 'collapse',
    icon: PaidOutlined,
    iconSelected: Paid,
    url: '/customers?module=sales',
    children: [
      {
        id: 'customers',
        title: 'Customers',
        type: 'item',
        url: '/customers?module=sales&submodule=customers',
        featureFlag: FEATURE_FLAGS.CUSTOMERS_MODULE_ENABLED
      },
      {
        id: 'quotes',
        title: 'Quotes',
        type: 'item',
        url: '/quotes?module=sales&submodule=quotes',
        featureFlag: FEATURE_FLAGS.QUOTES_MODULE_ENABLED
      }
    ]
  };

  const { items: filteredItems, isReady } = useFilterNavItemsByFeatureFlags([navItems]);
  return {
    item: filteredItems[0] ?? null,
    isReady
  };
};

export default SalesNavItems;
